// AccessibleMenu is available as a global variable from the vendors/accessible-menu.js file
export default () => {
    // get the main menu
    const nav = document.querySelector("#main-menu");

    // if there is no nav, return
    if (!nav) {
        return;
    }

    // get the menu element and the controller element
    const menuElement = nav.querySelector("ul");
    const controllerElement = nav.querySelector("button");

    // create the menu
    const menu = new AccessibleMenu.DisclosureMenu({
        menuElement,
        submenuItemSelector: ".dropdown",
        containerElement: nav,
        controllerElement,
        optionalKeySupport: true,
        hoverType: "off", // "on", "dynamic"
    });
}